"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/**
 * A utiliser sur les input qui doivent déclencher un changement dans une formule
 */
exports.default = {
    updated: function updated() {
        this.formulaChanged();
    },
    methods: {
        getFormulaValue: function getFormulaValue() {
            return this.value;
        },
        formulaChanged: function formulaChanged() {
            this.$root.$emit("formula-change", {
                name: this.name,
                value: this.getFormulaValue()
            });
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./_wwwsrc/js/Workflow/Mixins/FormulaInput.ts
// module id = 548
// module chunks = 0